import React from 'react';
import '../../assets/css/case-home.css';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken, RichTextContent } from '@vibesites/runtime/react';

export function CareersBenefits() {
  const videoTitle = useContentToken('careersbenefits.video_title');
  const videoUrl = useContentToken('careersbenefits.video_url');
  const benefitsTitle = useContentToken('careersbenefits.benefits_title');

  return (
    <section className="case-careerspage-benefits">
      <div className="case-container">
        {/* Career Benefits — full-width video */}
        <div className="case-careerspage-video-section">
          <EditableToken
            path="careersbenefits.video_title"
            type="text"
            label="Video Section Title"
            defaultValue={contentSchema.tokens['careersbenefits.video_title'].defaultValue}
            as="h2"
            style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1.5rem' }}
          >
            {videoTitle}
          </EditableToken>
          <div className="case-careerspage-video-wrap">
            <EditableToken path="careersbenefits.video_url" type="url" label="YouTube Video URL" defaultValue={contentSchema.tokens['careersbenefits.video_url'].defaultValue} as="div" style={{ width: '100%', height: '100%' }}>
              <iframe
                src={videoUrl as string}
                title="Case &amp; Associates Employment Opportunities Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </EditableToken>
          </div>
        </div>

        {/* Group Benefits — separate section with 2-column list */}
        <div className="case-careerspage-benefits-content">
          <EditableToken
            path="careersbenefits.benefits_title"
            type="text"
            label="Benefits Section Title"
            defaultValue={contentSchema.tokens['careersbenefits.benefits_title'].defaultValue}
            as="h2"
            style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem' }}
          >
            {benefitsTitle}
          </EditableToken>
          <RichTextContent
            path="careersbenefits.benefits_intro"
            label="Benefits Intro"
            defaultValue={contentSchema.tokens['careersbenefits.benefits_intro'].defaultValue}
            as="p"
            style={{ lineHeight: 1.6, marginBottom: '1.5rem' }}
          />
          <div className="case-careerspage-benefits-list">
            <RichTextContent
              path="careersbenefits.benefits_list"
              label="Benefits List"
              defaultValue={contentSchema.tokens['careersbenefits.benefits_list'].defaultValue}
              as="div"
            />
          </div>
          <RichTextContent
            path="careersbenefits.benefits_disclaimer"
            label="Benefits Disclaimer"
            defaultValue={contentSchema.tokens['careersbenefits.benefits_disclaimer'].defaultValue}
            as="div"
            className="case-careerspage-disclaimer"
          />
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'CareersBenefits',
  displayName: 'Careers Benefits',
  tokens: {
    'careersbenefits.video_title': {
      label: 'Video Section Title',
      type: 'text',
      defaultValue: 'Career Benefits',
    },
    'careersbenefits.video_url': {
      label: 'YouTube Video URL',
      type: 'url',
      defaultValue: 'https://www.youtube.com/embed/aJM8iX-rWE0',
    },
    'careersbenefits.benefits_title': {
      label: 'Benefits Section Title',
      type: 'text',
      defaultValue: 'Group Benefits',
    },
    'careersbenefits.benefits_intro': {
      label: 'Benefits Intro',
      type: 'richtext',
      defaultValue: 'Case &amp; Associates has excellent benefits for our eligible employees. We believe in investing in our employees, and this includes supporting each one of them with outstanding benefits.',
    },
    'careersbenefits.benefits_list': {
      label: 'Benefits List',
      type: 'richtext',
      defaultValue: '<ul><li>Medical \u2013 We offer medical insurance, as well as a 100% covered clinic for all covered employees and their dependents through CareATC in the Tulsa and Oklahoma City markets. We also offer services with ZeroCard and Teladoc.</li><li>Dental</li><li>Vision</li><li>Short &amp; Long Term Disability</li><li>Supplemental Benefits \u2013 AFLAC, Legal Shield, Employee Rent Discount</li><li>401K &amp; Roth Plans</li><li>Paid Time Off</li><li>Holidays</li><li>Bonus Program</li><li>Employee Assistance Program (EAP)</li><li><a href="http://transparency-in-coverage.uhc.com/" target="_blank" rel="noopener noreferrer">Transparency in Coverage</a></li></ul>',
    },
    'careersbenefits.benefits_disclaimer': {
      label: 'Benefits Disclaimer',
      type: 'richtext',
      defaultValue: '<p>We would love to discuss our benefits more in-depth with you!</p><p><em>*The information provided above is not intended to replace plan descriptions.</em></p>',
    },
  },
};

(CareersBenefits as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default CareersBenefits;
